import React from 'react';
import { Row } from 'react-bootstrap';
import { translate } from 'react-i18next';

@translate(['common'])

export default class ModeOpe extends React.Component {

 
	render() {
		const { t } = this.props;

		return (
			<div style={{ padding: "0 15px" }}>
				<Row>
					<h2 style={{ marginTop: '0px', paddingTop: '0px' }}>
						{t('modeOpe.title')}
					</h2>

					<h3>
						{t('modeOpe.step1')}
					</h3>

					<h4>
						{t('modeOpe.data_server_info')}
					</h4>


					<ul className="list-group">

						<li className="list-group-item">
							{t('main.open')} <i><b>{t('modeOpe.identification')}</b></i> {t('modeOpe.provide_mandatory_fields')} :
        	  			</li>

						<li className="list-group-item">
							<span style={{ color: "orange" }} ><b>{t('modeOpe.liftType')}</b></span> / {t('modeOpe.liftTypeDesc')}
        	  			</li>

						<li className="list-group-item">
							<span style={{ color: "orange" }} ><b>{t('modeOpe.num_lifts')}</b></span> / {t('modeOpe.lift_number')}
        	  			</li>

						<li className="list-group-item">
							<span style={{ color: "orange" }} ><b>{t('modeOpe.id_ptu')}</b></span>  / {t('modeOpe.ptu80_id_code')}
        	  			</li>

						<li className="list-group-item">
							<span style={{ color: "orange" }} ><b>{t('modeOpe.gsm_number')} {t('main.or')} {t('productFormInputs.identification_EQUIPSN')}</b></span> / {t('modeOpe.telealarm_num')} {t('main.or')} {t('modeOpe.identification_EQUIPSN')}
        	  			</li>

						<li className="list-group-item">
							<span style={{ color: "orange" }} ><b>{t('modeOpe.num_module')}</b></span>  / {t('modeOpe.adressage_telealarm')}
        	  			</li>

						<li className="list-group-item">
							{t('modeOpe.appel_tech_pit')} :
        					<span style={{ color: "orange" }} ><b>{t('modeOpe.numero_module')}</b></span>{t('modeOpe.2to5')} <span style={{ color: "orange" }} ><b>{t('modeOpe.id_ptu')}</b></span> / {t('modeOpe.pit_code_id')}
						</li>

						<li className="list-group-item">
							{t('main.open')}Ouvrir <i><b>{t('modeOpe.localisation')}</b></i> {t('modeOpe.fill_orange_field')}
        				</li>

						<li className="list-group-item">
							<span style={{ color: "orange" }} ><b>{t('modeOpe.address_de_linstall')}</b></span> / {t('modeOpe.physical_address')}
        				</li>

						<li className="list-group-item list-group-item-warning">
							{t('modeOpe.indicator_to_orange')}
        				</li>

					</ul>

				</Row>

				<Row>
					<h3>
						{t('modeOpe.step2')}
					</h3>

					<h4>
						{t('modeOpe.ptu_sync_server')}<br />{t('modeOpe.only_master_sheets')}
					</h4>

					<ul className="list-group">

						<li className="list-group-item">
							{t('modeOpe.functioning_alarms')}
        				</li>

						<li className="list-group-item">
							{t('main.open')} <i><b>FTP</b></i>
						</li>

						<li className="list-group-item">
							{t('modeOpe.clickOn')} <b>{t('modeOpe.activate_ftp')}</b>,
        				</li>

						<li className="list-group-item">
							<i className='fa fa-cog fa-spin' />  {t('modeOpe.data_exchange')} <i className='fa fa-cog fa-spin' />
						</li>

						<li className="list-group-item">
							{t('modeOpe.ftp_actif')}
						</li>

						<li className="list-group-item list-group-item-info">
							{t('modeOpe.indicator_to_blue')}
        				</li>

					</ul>
				</Row>

				<Row>

					<h3>{t('modeOpe.step3')}</h3>

					<h4>{t('modeOpe.title3')}</h4>

					<ul className="list-group">

						<li className="list-group-item">
							{t('modeOpe.configure_functions')}
        				</li>

						<li className="list-group-item">
							<i className='fa fa-cog fa-spin' /> {t('modeOpe.reception_validation')}  <i className='fa fa-cog fa-spin' />
						</li>

						<li className="list-group-item list-group-item-success">
							{t('modeOpe.indicator_to_green')}
        				</li>

					</ul>

				</Row>

			</div>
		);
	}
}